<template>
  <!-- 电子码活动 -->
  <div>
    <div class="wrapper"
         v-if="activeStatus===true">
      <div><img :src="coverImg"
             style="display:block; width:1rem;"></div>
      <div class="formwrap"
           :style="{backgroundImage:'url('+ bgImg +')'}">
        <div class="formbox"
             v-show="!isRepeat">
          <div class="formtt">领取礼券</div>
          <div class="inputbox">
            <input type="text"
                   v-model="phone"
                   placeholder="请输入手机号"
                   class="txtinput"
                   maxlength="11">
          </div>
          <div class="inputbox">
            <input type="text"
                   style="float:left;"
                   v-model="code"
                   placeholder="短信验证码"
                   class="txtinput"
                   maxlength="6">
            <span @click="sendCode"
                  :class="['btnsend',{'disabled':sendStatus}]">{{sendStatus? (sendCount+'s后重新获取'):'获取验证码'}}</span>
          </div>
          <Verify
            @close="boxClose"
            @success="success"
            :mode="'pop'"
            :captchaType="'blockPuzzle'"
            :imgSize="{ width: '330px', height: '155px' }"
            ref="verify"
          ></Verify>
          <div class="btnsub"
               @click="draw">提交</div>
        </div>
        <div class="couplebox"
             v-show="ecode">
          <p class="couplett">券码信息</p>
          <p class="couplenum">{{ecode}}</p>
        </div>
        <div class="rulebox"
             v-show="!isRepeat">
          <div class="rulein">
            <div class="rulett">领取须知</div>
            <div class="rulenote">
              <p>有效期</p>
              <p>{{activityStart}}至{{activityEnd}}</p>
              <p>领取规则</p>
              <p v-html="ruleText"></p>
            </div>
          </div>
        </div>
        <div class="rulebox"
             v-show="isRepeat">
          <div class="rulein">
            <div class="rulett">使用须知</div>
            <div class="rulenote">
              <p>不可用日期</p>
              <p>{{limitDate}}</p>
              <p>使用时间</p>
              <p>{{daterange}}</p>
              <!-- <p>使用范围</p>
              <p>{{faceShops}}</p> -->
              <p>使用说明</p>
              <p v-html="instructionText"></p>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="wrapper"
         v-if="activeStatus===false">
      <img :src="emptyPic"
           class="emptyPic">
      <p class="emptyp">{{tips}}</p>
    </div>
  </div>
</template>

<script>
import Verify from '@/components/verifition/Verify'
Date.prototype.Format = function (fmt) { //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}
export default {
  name: "ecode_activity",
  components: { Verify },
  data () {
    return {
      loginFlag: false,
      tips: '',
      emptyPic: require('@a/empty_no.png'),
      activeStatus: '',
      isRepeat: false,
      phone: '',
      code: '',
      sendStatus: false,
      sendCount: 60,
      activityStart: '',
      activityEnd: '',
      ecode: '',
      coverImg: '',
      bgImg: '',
      faceShops: '',
      ruleText: '',
      instructionText: '',
      limitDate: '',
      daterange: '',
      ecodeProductId: ''
    }
  },
  created () {
    this.coverImg = this.$route.query.coverImg || ''
    this.bgImg = this.$route.query.bgImg || ''
    this.ruleText = (this.$route.query.ruleText || '').replace(/\n/g, "<br/>")
    this.activityStart = this.$route.query.activityStart || ''
    this.activityEnd = this.$route.query.activityEnd || ''
    if (this.$route.query.merchantId && this.$route.query.activityId) {
      let params = {
        merchantId: this.$route.query.merchantId,
        activityId: this.$route.query.activityId
      }
      if (this.$route.query.externalMemberId) {
        params.externalMemberId = this.$route.query.externalMemberId
      }
      if (this.$route.query.externalSource) {
        params.externalSource = this.$route.query.externalSource
      }
      this.API.ecodePage(params).then(res => {
        if (res.status === 200 && res.data.activityType === 1) {
          document.title = res.data.pageData.activityName
          this.activeStatus = true
          this.coverImg = res.data.pageData.coverImg
          this.bgImg = res.data.pageData.bgImg
          this.isRepeat = res.data.pageData.isRepeat
          if (res.data.pageData.isRepeat) {
            this.instructionText = (res.data.pageData.instructionText || '').replace(/\n/g, "<br/>")
            this.ecode = res.data.pageData.ecodeNo
            this.faceShops = res.data.pageData.shopLimits
            if (res.data.pageData.periodType == 0) {
              this.daterange = res.data.pageData.beginAt + '至' + res.data.pageData.endAt
            } else {
              this.daterange = new Date(res.data.pageData.updatedAt).Format("yyyy-MM-dd hh:mm:ss") + '至' + new Date(new Date(res.data.pageData.updatedAt).getTime() + res.data.pageData.days * 24 * 3600 * 1000).Format("yyyy-MM-dd hh:mm:ss")
            }
            if (!res.data.pageData.limitType) {
              this.limitDate = '无限制'
            } else if (res.data.pageData.limitType === 1) {
              this.limitDate = res.data.pageData.limitDay.split(',').map(item => {
                return ['周一', '周二', '周三', '周四', '周五', '周六', '周日'][item - 1]
              }).join(',')
            } else if (res.data.pageData.limitType === 2) {
              this.limitDate = '国定节假日'
              if (res.data.pageData.limitDate.length) {
                this.limitDate = this.limitDate + '加' + res.data.pageData.limitDay.split(',').map(item => {
                  return ['周一', '周二', '周三', '周四', '周五', '周六', '周日'][item - 1]
                }).join(',')
              }
            }
          } else {
            this.ruleText = (res.data.pageData.ruleText || '').replace(/\n/g, "<br/>")
            this.activityStart = res.data.pageData.activityStart
            this.activityEnd = res.data.pageData.activityEnd
            this.ecodeProductId = res.data.pageData.ecodeProductId
          }
        } else {
          this.activeStatus = false
          if (res.errorCode === '10003') {
            this.tips = '没有电子码'
          }
          if (res.errorCode === '10008') {
            this.tips = '您来迟了，活动已结束'
          }
        }
      })
    } else {
      this.activeStatus = true
    }
  },
  mounted () { },
  methods: {
    draw () {
      if (this.phone == '') {
        this.$toast({ content: '请输入您的手机号' })
        return
      }
      if (!/^1\d{10}$/.test(this.phone)) {
        this.$toast({ content: '请输入正确的手机号' })
        return
      }
      if (this.code == '') {
        this.$toast({ content: '请输入短信验证码' })
        return
      }
      let params = {
        merchantId: this.$route.query.merchantId,
        ecodeProductId: this.ecodeProductId,
        phone: this.phone,
        validCode: this.code,
        activityId: this.$route.query.activityId
      }
      if (this.$route.query.externalMemberId) {
        params.externalMemberId = this.$route.query.externalMemberId
      }
      if (this.$route.query.externalSource) {
        params.externalSource = this.$route.query.externalSource
      }
      if (this.$route.query.appId) {
        params.appId = this.$route.query.appId
      }
      this.API.ecodeDraw(params).then(res => {
        if (res.status === 200) {
          this.$toast({ content: '领取成功' })
          // window.location.reload()
          this.activeStatus = true
          this.coverImg = res.data.coverImg
          this.bgImg = res.data.bgImg
          this.isRepeat = true
          this.instructionText = (res.data.instructionText || '').replace(/\n/g, "<br/>")
          this.ecode = res.data.ecodeNo
          this.faceShops = res.data.shopLimits
          if (res.data.periodType == 0) {
            this.daterange = res.data.beginAt + '至' + res.data.endAt
          } else {
            this.daterange = new Date(res.data.updatedAt).Format("yyyy-MM-dd hh:mm:ss") + '至' + new Date(new Date(res.data.updatedAt).getTime() + res.data.days * 24 * 3600 * 1000).Format("yyyy-MM-dd hh:mm:ss")
          }
          if (!res.data.limitType) {
            this.limitDate = '无限制'
          } else if (res.data.limitType === 1) {
            this.limitDate = res.data.limitDay.split(',').map(item => {
              return ['周一', '周二', '周三', '周四', '周五', '周六', '周日'][item - 1]
            }).join(',')
          } else if (res.data.limitType === 2) {
            this.limitDate = '国定节假日'
            if (res.data.limitDate.length) {
              this.limitDate = this.limitDate + '加' + res.data.limitDay.split(',').map(item => {
                return ['周一', '周二', '周三', '周四', '周五', '周六', '周日'][item - 1]
              }).join(',')
            }
          }
        } else {
          this.$toast({ content: res.error })
        }
      })

    },
    boxClose (val) {
      val && (this.loginFlag = false)
    },
    success ({ captchaVerification }) {
      let timer
      this.API.sendSms({
        merchantId: this.$route.query.merchantId,
        phone: this.phone,
        captchaVerification
      }).then(res => {
        if (res.status === 200) {
          this.sendStatus = true
          this.$toast({ content: '短信验证码已发送' })
          timer = setInterval(() => {
            if (this.sendCount == 0) {
              this.loginFlag = false
              this.sendStatus = false
              this.sendCount = 60
              clearInterval(timer)
            } else {
              this.sendCount = this.sendCount - 1
            }
          }, 1000);
        } else {
          this.loginFlag = false
          this.$toast({ content: res.error })
        }
      }).catch(() => {
        this.loginFlag = false
      })
    },
    sendCode () {
      // if (this.sendStatus) {
      //   return
      // }
      if (this.phone == '') {
        this.$toast({ content: '请输入您的手机号' })
        return
      }
      if (!/^1\d{10}$/.test(this.phone)) {
        this.$toast({ content: '请输入正确的手机号' })
        return
      }
      if (this.loginFlag) {
        return
      }
      this.$refs.verify.show()
      this.loginFlag = true
    }
  }
};
</script>
<style>
body {
  background: #f5f7fc;
}
</style>
<style lang="less" scoped>
.wrapper {
  width: 1rem;
}
.formwrap {
  width: 1rem;
  padding: 0 0.064rem 0.15333333333333332rem;
  background-repeat: no-repeat;
  background-size: 1rem auto;
  background-position: 0 0;
}
.formbox {
  background: #fff;
  width: 0.872rem;
  height: 0.768rem;
  border-radius: 0.042666666666666665rem;
}
.rulebox {
  background: #fff;
  width: 0.872rem;
  border-radius: 0.042666666666666665rem;
  margin-top: 0.032rem;
}
.rulein {
  padding: 0.08rem 0.064rem 0.10666666666666667rem;
}
.rulett {
  font-weight: 500;
  font-size: 0.053333rem;
  color: #333333;
  padding-bottom: 0.05rem;
  border-bottom: 1px solid #e8e8e8;
}
.rulenote {
  p {
    font-size: 0.037333rem;
    padding-top: 0.04rem;
    line-height: 1.5;
  }
}
.couplebox {
  background: #fff;
  width: 0.872rem;
  height: 0.42rem;
  border-radius: 0.042666666666666665rem;
  margin-top: 0.032rem;
}
.couplett,
.formtt {
  font-weight: 500;
  width: 0.744rem;
  color: #333333;
  border-bottom: 1px solid #e8e8e8;
  padding-top: 0.08rem;
  padding-bottom: 0.05rem;
  margin-left: 0.064rem;
  font-size: 0.053333rem;
}
.couplenum {
  color: #333333;
  padding-top: 0.07rem;
  margin-left: 0.064rem;
  font-size: 0.05rem;
}
.inputbox {
  height: 0.148rem;
  overflow: hidden;
  border-bottom: 1px solid #e8e8e8;
  margin-left: 0.064rem;
  width: 0.744rem;
}
.txtinput {
  line-height: 0.148rem;
  width: 0.4rem;
  height: 0.148rem;
  background: none;
  border: none;
  color: #333333;
}
.btnsend {
  width: 0.293333rem;
  margin-top: 0.025333rem;
  float: right;
  text-align: center;
  line-height: 0.096rem;
  height: 0.096rem;
  background: linear-gradient(319deg, #ffbc26 0%, #ffd800 100%);
  border-radius: 0.021333rem;
}
.btnsend.disabled {
  color: #fff;
  background: #ccc;
}
.btnsub {
  width: 0.490667rem;
  height: 0.106667rem;
  line-height: 0.106667rem;
  margin: 0.073333rem auto 0;
  background: linear-gradient(319deg, #ffbc26 0%, #ffd800 100%);
  border-radius: 0.021333rem;
  text-align: center;
  font-size: 0.042667rem;
}
.emptyPic {
  width: 0.5rem;
  height: 0.5rem;
  margin: 0.5rem 0.25rem 0;
}
.emptyp {
  text-align: center;
  font-size: 0.034667rem;
  color: #a2a3b8;
  padding-top: 0.094667rem;
}
</style>
